// Module
var code = "<template>\n  <require from=\"./service-kpi-estimates-service-queue\"></require>\n\n  <service-kpi-estimates-service-queue></service-kpi-estimates-service-queue>\n</template>\n";
// Exports
export default code;